import { DeleteOutlined, EditOutlined, MoreOutlined, EyeOutlined } from "@ant-design/icons";
import { Dropdown, message, Space, Switch, Table } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
// import formatDateTime from "utils/formatter/formatDateTime";
import { useDispatch, useSelector } from "react-redux";
import TableAntd from "components/elements/Table/Table";
import { setIsLoading } from "features/accountCategory/slices/accountCategorySlice";
import { calNewLeaveBenefitByLeaveType } from "features/employee/services/employeeApi";
import { useCallback, useEffect } from "react";
import { storage } from "lib";
const LeaveTypeTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onStatus = () => { },
  onEdit = () => { },
  onDelete = () => { },
  onChange = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const dispatch = useDispatch();


  function formatDateTime(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    return date.format(i18n.language === "en" ? "DD/MM/YYYY HH:mm" : `DD/MM/${date.year() + 543}  HH:mm น.`);
  }

  const currentCompany = storage.localStorage.getItem("currentCompany");

  const onCalculate = useCallback(async (leaveTypeId) => {
    console.log(leaveTypeId);

    try {
      dispatch(setIsLoading(true));
      message.loading(t("common.loading"), 99999)
      await calNewLeaveBenefitByLeaveType({
        companyId: currentCompany,
        leaveTypeId,
        timeout: 9999999,
        // employeeId: id,
        // year: selectedYear,
      });
      message.destroy()
      message.success(t("common.success"))
    } catch (error) {
      console.error('Error calculating leave benefit:', error);
      message.error(t("common.error"))
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany]);


  const columns = [
    {
      title: <div className="text-table">{t("common.index")}</div>,
      dataIndex: "index",
      key: "index",
      width: 100,
      align: "center",
      render: (_, record, idx) => {
        return (pagination.page - 1) * pagination.size + idx + 1;
      },
    },
    {
      title: <div className="text-table">{t("leave_type_type")}</div>,
      dataIndex: "leaveTypeName",
      key: "leaveTypeName",
      sorter: {
        compare: (a, b) => null,
        multiple: 5,
      },
      render: (_, record) => {
        const name =
          i18n.language === "en"
            ? record.leaveTypeNameEn
            : record.leaveTypeName;
        return name;
      },
    },
    {
      title: <div className="text-table">{t("leave_type_description")}</div>,
      dataIndex: "description",
      key: "description",
    },
    {
      title: <div className="text-table">{t("leave_type_last_modified")}</div>,
      dataIndex: "updateDate",
      key: "updateDate",
      sorter: {
        compare: (a, b) => null,
        multiple: 5,
      },
      render: (_, record) => {
        // const { lastModified = {} } = record;
        const language = i18n.language === "en" ? "En" : "";
        const nameBy = record?.updateBy ? "updateBy" : "createBy"
        const name = record?.[nameBy]?.["name" + language] + " " + record?.[nameBy]?.["surName" + language]
        return (
          <>
            {name}
            <br />
            {record.updateDate ? formatDateTime(record.updateDate) : formatDateTime(record.createDate) ?? "-"}
          </>
        );
      },
    },
    {
      title: <div className="text-table">{t("leave_type_status")}</div>,
      dataIndex: "statusFlag",
      key: "statusFlag",
      sorter: {
        compare: (a, b) => null,
        multiple: 5,
      },
      render: (text, record) => (
        <Switch
          checked={text === "ACTIVE"}
          onChange={(checked) => onStatus(checked, record)}
          disabled={roles.includes("UPDATE_CONFIGURATION|ATTENDANCE_SETTING|LEAVE_TYPE") ? false : true}
        />
      ),
    },
    {
      title: "",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                {
                  key: "0",
                  onClick: () => onEdit({ ...record, isView: "Y" }),
                  label: `${t("action.view")}`,
                  icon: (
                    <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                roles.includes("UPDATE_CONFIGURATION|ATTENDANCE_SETTING|LEAVE_TYPE") && {
                  key: "1",
                  onClick: () => onEdit(record),
                  label: `${t("action.edit")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                roles.includes("UPDATE_CONFIGURATION|ATTENDANCE_SETTING|LEAVE_TYPE") && {
                  key: "2",
                  onClick: () => onCalculate(record.id),
                  label: `${t("calculate")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                roles.includes("DELETE_CONFIGURATION|ATTENDANCE_SETTING|LEAVE_TYPE") && {
                  key: "3",
                  onClick: () => onDelete(record),
                  label: `${t("action.delete")}`,
                  icon: (
                    <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    },
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
      scroll={{ x: true }}
    />
  );
};

export default LeaveTypeTable;
